/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as NotificationDefs from './defs.defs.js'

const $nsid = 'app.bsky.notification.putPreferencesV2'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  chat: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.ChatPreference>(
      (() => NotificationDefs.chatPreference) as any,
    ),
  ),
  follow: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.FilterablePreference>(
      (() => NotificationDefs.filterablePreference) as any,
    ),
  ),
  like: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.FilterablePreference>(
      (() => NotificationDefs.filterablePreference) as any,
    ),
  ),
  likeViaRepost: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.FilterablePreference>(
      (() => NotificationDefs.filterablePreference) as any,
    ),
  ),
  mention: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.FilterablePreference>(
      (() => NotificationDefs.filterablePreference) as any,
    ),
  ),
  quote: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.FilterablePreference>(
      (() => NotificationDefs.filterablePreference) as any,
    ),
  ),
  reply: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.FilterablePreference>(
      (() => NotificationDefs.filterablePreference) as any,
    ),
  ),
  repost: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.FilterablePreference>(
      (() => NotificationDefs.filterablePreference) as any,
    ),
  ),
  repostViaRepost: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.FilterablePreference>(
      (() => NotificationDefs.filterablePreference) as any,
    ),
  ),
  starterpackJoined: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.Preference>(
      (() => NotificationDefs.preference) as any,
    ),
  ),
  subscribedPost: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.Preference>(
      (() => NotificationDefs.preference) as any,
    ),
  ),
  unverified: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.Preference>(
      (() => NotificationDefs.preference) as any,
    ),
  ),
  verified: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.Preference>(
      (() => NotificationDefs.preference) as any,
    ),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  preferences: /*#__PURE__*/ l.ref<NotificationDefs.Preferences>(
    (() => NotificationDefs.preferences) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Set notification-related preferences for an account. Requires auth. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
